import React from 'react';
import { LandingPage } from './pages/LandingPage';
import { TermsPage } from './pages/TermsPage';
import { PrivacyPage } from './pages/PrivacyPage';
import { CookiesPage } from './pages/CookiesPage';
import { RefundsPage } from './pages/RefundsPage';
export function App() {
  const path = window.location.pathname;
  if (path === '/terminos') return <TermsPage data-id="element-0" />;
  if (path === '/privacidad') return <PrivacyPage data-id="element-1" />;
  if (path === '/cookies') return <CookiesPage data-id="element-2" />;
  if (path === '/reembolsos') return <RefundsPage data-id="element-3" />;
  return <LandingPage data-id="element-4" />;
}